module.exports = __webpack_public_path__ + "media/images/print_report_logo-1173feebb0f4e652d4b2f71f25cd2fab.png";